import { isMyAppWKWebView } from "./isMyAppWKWebView";

export async function openUrl(url: string) {
  // For Android WebView
  if (window.Android) {
    // Use in-app method if available
    // if (window.Android.openUrlInApp) {
    //   return window.Android.openUrlInApp(url);
    // }
    return window.Android.openUrl(url);
  }

  // For iOS WKWebView
  if (isMyAppWKWebView()) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    const webkit = window.webkit as any;
    
    if (webkit.messageHandlers.openUrlInApp) {
      return webkit.messageHandlers.openUrlInApp.postMessage(url);
    }
    // return webkit.messageHandlers.openUrl.postMessage(url);
  }

  // For standard web browsers - always use in-app behavior
  try {
    // Use direct navigation for in-app experience
    window.location.href = url;
    return true;
  } catch {
    window.location.href = url;
    return false;
  }
}